(() => {
  const tabs = document.querySelector('.hb-cart-tabs');
  if (!tabs) return;
  const cart = document.querySelector('#Cart-panel');
  const extras = document.querySelector('#Extras-panel');
  const buttons = [...tabs.querySelectorAll('[role="tab"]')];
  tabs.hidden = false;
  cart.setAttribute('role', 'tabpanel'); cart.setAttribute('aria-labelledby', 'Cart-tab');
  extras.setAttribute('role', 'tabpanel'); extras.setAttribute('aria-labelledby', 'Extras-tab');
  const activate = index => {
    buttons.forEach((button, i) => { button.setAttribute('aria-selected', String(i === index)); button.tabIndex = i === index ? 0 : -1; });
    cart.hidden = index !== 0;
    extras.hidden = index !== 1;
  };
  buttons.forEach((button, index) => {
    button.addEventListener('click', () => activate(index));
    button.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : 1 - index;
      activate(next); buttons[next].focus();
    });
  });
  const back = document.querySelector('[data-back-to-cart]');
  back.hidden = false;
  back.addEventListener('click', () => { activate(0); buttons[0].focus(); });
  document.querySelectorAll('.hb-cart__extra form').forEach(form => {
    form.querySelector('select')?.addEventListener('change', event => {
      form.querySelector('[data-extra-price]').textContent = event.target.selectedOptions[0].dataset.price;
    });
  });
  document.querySelectorAll('[data-open-extras]').forEach(link => link.addEventListener('click', event => {
    event.preventDefault(); activate(1); buttons[1].focus(); tabs.scrollIntoView({ block: 'start' });
  }));
  activate(0);
})();
